/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 8H15M7 12H11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V19.1708C22 20.1969 22 20.71 21.8373 21.0302C21.5642 21.5676 20.996 21.8893 20.3947 21.847C20.0363 21.8218 19.5964 21.5578 18.7165 21.0299V21.0299C18.1917 20.715 17.9293 20.5576 17.6542 20.4347C17.1972 20.2306 16.7122 20.0962 16.2154 20.0362C15.9163 20 15.6103 20 14.9983 20H10C7.19974 20 5.79961 20 4.73005 19.455C3.78924 18.9757 3.02433 18.2108 2.54497 17.27C2 16.2004 2 14.8003 2 12V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V19.1708C22 20.1969 22 20.71 21.8373 21.0302C21.5642 21.5676 20.996 21.8893 20.3947 21.847C20.0363 21.8218 19.5964 21.5578 18.7165 21.0299C18.1917 20.715 17.9293 20.5576 17.6542 20.4347C17.1972 20.2306 16.7122 20.0963 16.2154 20.0362C15.9163 20 15.6103 20 14.9983 20H10C7.19974 20 5.79961 20 4.73005 19.455C3.78924 18.9757 3.02433 18.2108 2.54497 17.27C2 16.2004 2 14.8003 2 12V10Z"
				fill="currentColor"
			/>
			<path
				d="M7 8H15M7 12H11M18.7165 21.0299V21.0299C19.5964 21.5578 20.0363 21.8218 20.3947 21.847C20.996 21.8893 21.5642 21.5676 21.8373 21.0302C22 20.71 22 20.1969 22 19.1708V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V12C2 14.8003 2 16.2004 2.54497 17.27C3.02433 18.2108 3.78924 18.9757 4.73005 19.455C5.79961 20 7.19974 20 10 20H14.9983C15.6103 20 15.9163 20 16.2154 20.0362C16.7122 20.0962 17.1972 20.2306 17.6542 20.4347C17.9293 20.5576 18.1917 20.715 18.7165 21.0299Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V20.0858C22.75 21.4732 22.75 22.1669 22.4591 22.5631C22.2054 22.9086 21.816 23.1291 21.3892 23.1689C20.8998 23.2145 20.3049 22.8576 19.1152 22.1438L18.6924 21.8901L18.6923 21.89C17.9851 21.4657 17.6315 21.2535 17.254 21.1035C16.9189 20.9703 16.5703 20.8738 16.2144 20.8156C15.8135 20.75 15.4012 20.75 14.5764 20.75H9.25C6.44974 20.75 5.04961 20.75 3.98005 20.205C3.03924 19.7257 2.27433 18.9608 1.79497 18.02C1.25 16.9504 1.25 15.5503 1.25 12.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM7 7.25C6.58579 7.25 6.25 7.58579 6.25 8C6.25 8.41421 6.58579 8.75 7 8.75H15C15.4142 8.75 15.75 8.41421 15.75 8C15.75 7.58579 15.4142 7.25 15 7.25H7ZM7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H11C11.4142 12.75 11.75 12.4142 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25H7Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 11V10.5V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V12C2 14.8003 2 16.2004 2.54497 17.27C3.02433 18.2108 3.78924 18.9757 4.73005 19.455C5.79961 20 7.19974 20 10 20H14.9983C15.6103 20 15.9163 20 16.2154 20.0362C16.7122 20.0962 17.1972 20.2306 17.6542 20.4347C17.9293 20.5576 18.1917 20.715 18.7165 21.0299V21.0299C19.5964 21.5578 20.0363 21.8218 20.3947 21.847C20.996 21.8893 21.5642 21.5676 21.8373 21.0302C22 20.71 22 20.1969 22 19.1708V16M7 8H15M7 12H11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 8H15M7 12H11M18.7165 21.0299V21.0299C19.5964 21.5578 20.0363 21.8218 20.3947 21.847C20.996 21.8893 21.5642 21.5676 21.8373 21.0302C22 20.71 22 20.1969 22 19.1708V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V12C2 14.8003 2 16.2004 2.54497 17.27C3.02433 18.2108 3.78924 18.9757 4.73005 19.455C5.79961 20 7.19974 20 10 20H14.9983C15.6103 20 15.9163 20 16.2154 20.0362C16.7122 20.0962 17.1972 20.2306 17.6542 20.4347C17.9293 20.5576 18.1917 20.715 18.7165 21.0299Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V12.75C1.25 15.5503 1.25 16.9504 1.79497 18.02C2.27433 18.9608 3.03924 19.7257 3.98005 20.205C5.04961 20.75 6.44974 20.75 9.25 20.75H14.5764C15.4012 20.75 15.8135 20.75 16.2144 20.8156C16.5703 20.8738 16.9189 20.9703 17.254 21.1035C17.6315 21.2535 17.9851 21.4657 18.6924 21.8901L19.1152 22.1438C20.3049 22.8576 20.8998 23.2145 21.3892 23.1689C21.816 23.1291 22.2054 22.9086 22.4591 22.5631C22.75 22.1669 22.75 21.4732 22.75 20.0858V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.25 8C6.25 7.58579 6.58579 7.25 7 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H7C6.58579 8.75 6.25 8.41421 6.25 8ZM6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H11C11.4142 11.25 11.75 11.5858 11.75 12C11.75 12.4142 11.4142 12.75 11 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
